module.exports = __webpack_public_path__ + "static/media/instant_reporting.9fbc58ea.png";